import React from 'react';
import { injectIntl, useIntl, FormattedMessage } from 'react-intl';
import btnClose from '../../images/common/close.svg';

import {
  Main,
  BaseDialog,
  Header,
  Contents,
  CloseButton,
  CloseButtonImage,
  ImportInput,
  MessageItem,
} from '../../styles/common/Dialog';
import {
  MessageWrapper,
  ButtonWrapper,
  ImportButton,
} from './styles/OneLayerMasterImportDialogStyles';
import useOneLayerMasterImport from './hooks/useOneLayerMasterImport';

/**
 * 選択した1層のインポートダイアログを表示
 * CSVファイルを選択して1層分のタグをインポートできる
 */
const OneLayerMasterImportDialog = () => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    importInputRef,
    handleCloseDialog,
    handleImportButtonClick,
    handleFileChange,
    selectedTag,
  } = useOneLayerMasterImport();

  return (
    <Main
      id="closeConfirmMasterImportDialog"
      role="presentation"
      onClick={handleCloseDialog}
    >
      <BaseDialog role="presentation" onClick={e => e.stopPropagation()}>
        <Contents>
          <Header>
            {selectedTag.depth === 0
              ? formatMessage({ id: 'master.TagSetImportDialog.title' })
              : formatMessage({
                  id: 'master.OneLayerMasterImportDialog.title',
                }).replace('{depth}', selectedTag.depth)}
            <CloseButton
              id="closeButton"
              role="presentation"
              className="button"
              onClick={handleCloseDialog}
            >
              <CloseButtonImage src={btnClose} alt="close" />
            </CloseButton>
          </Header>
          <div>
            <MessageWrapper>
              <MessageItem>
                {selectedTag.depth === 0
                  ? formatMessage({ id: 'master.TagSetImportDialog.message1' })
                  : formatMessage({
                      id: 'master.OneLayerMasterImportDialog.message1',
                    }).replace('{depth}', selectedTag.depth)}
              </MessageItem>
              <MessageItem>
                <FormattedMessage id="master.OneLayerMasterImportDialog.message2" />
              </MessageItem>
              <MessageItem>
                <FormattedMessage id="master.OneLayerMasterImportDialog.message3" />
              </MessageItem>
            </MessageWrapper>
            <ButtonWrapper>
              <ImportButton onClick={handleImportButtonClick}>
                <ImportInput
                  ref={importInputRef}
                  type="file"
                  accept=".csv"
                  onChange={e => handleFileChange(e.target.files[0])}
                />
                <FormattedMessage id="master.OneLayerMasterImportDialog.button.import" />
              </ImportButton>
            </ButtonWrapper>
          </div>
        </Contents>
      </BaseDialog>
    </Main>
  );
};

export default injectIntl(OneLayerMasterImportDialog);
